import React, { useContext } from 'react';
import Head from 'next/head';
import { PageType } from 'types/publishedAssets';
import { PageContext } from 'src/context/PageContext';
import { useGetContentTranslations } from 'utils/useGetContentTranslations';
import { useTranslatableField } from 'utils/useTranslatableField';
import { determineThemeName } from 'utils/determineUrls';
import { buildPublicUrlFromSlug } from 'utils/publicUrlRule';
import { determineLogoImage, determinePageDescription, determinePageTitle } from './PageHelpers';

interface PageProps {
  page: PageType;
}
export function PageOpenGraph(props: PageProps): JSX.Element | null {
  const { page } = props;
  const { slug, theme, urlParams, canonicalHostname } = useContext(PageContext);
  const { translateField } = useTranslatableField(urlParams?.locale);
  const { translate } = useGetContentTranslations();
  return (
    <Head>
      <meta property="og:title" content={determinePageTitle(page, translate)} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={slug[1]} />
      <meta property="og:url" content={buildPublicUrlFromSlug(slug, canonicalHostname)} />
      <meta property="og:description" content={determinePageDescription(page, translate)} />
      <meta property="og:image" content={determineLogoImage(theme!, translateField) || ''} />
      <meta property="og:siteName" content={determineThemeName(theme, translateField) || ''} />
    </Head>
  );
}
